<template>
  <!-- BEGIN: Responsive Table -->
  <div
    class="bg-white rounded-md content-container overflow-auto scrollbar_custom p-3"
  >
    <ContoApertoTable :global="true" @showPdf="handleShowPdf" />
    <div class="flex w-full justify-end p-4">
      <button
        class="orange-btn flex items-center gap-3"
        @click="openExportModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          class="w-5 fill-current"
        >
          <path
            d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
          />
        </svg>
        Esporta
      </button>
    </div>
    
  </div>
  <ExportContoApertoModal  v-if="export_modal" @close="closeExportModal"/>
  <!-- END: Responsive Table -->
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import axios from '../../gateway/backend-api'
import ContoApertoTable from '../../components/tables/ContoApertoTable.vue'
import ExportContoApertoModal from '../../components/modals/ExportContoApertoModal.vue'

const forPageOption = [5, 10, 20, 50]
export default defineComponent({
  components: {
    ContoApertoTable,
    ExportContoApertoModal
  },
  props: {},
  emits: [],
  data() {
    return {
      tableConfig_clinic_doc: [
        {
          key: 'number',
          title: 'Numero',
          type: 'text'
        },
        {
          key: 'datetime',
          title: 'Data',
          type: 'date'
        },
        {
          key: 'customer_id',
          title: 'Cliente',
          type: 'text'
        },
        {
          key: 'buttons',
          title: 'Azioni rapide',
          type: 'none'
        }
      ],
      elemFromPrev: {},
      invoiceModalOpen: false,
      confirmOpen: false,
      confirmString: '',
      docs: null,
      totalRecords: '',
      forPageOption,
      pagination: {
        page: 1,
        forPage: forPageOption[0]
      },
      services: [],
      tipoDocumento: 'preventivo',
      export_modal: false
    }
  },
  computed: {
    ...mapGetters({
      permissions: 'reusableData/getPermissions',
      user: 'getUser'
    })
  },
  watch: {
    'pagination.page': function (elem) {
      if (elem) this.getBills()
    },
    'pagination.forPage': function (elem) {
      if (elem) this.getBills()
    }
  },
  mounted() {
    this.getBills()
  },
  methods: {
    getBills() {
      this.$store.dispatch('commonComponents/showLoadingModalAction')
      axios
        .post('/' + localStorage.getItem('clinic') + '/account')
        .then((res) => {
          this.docs = res.data.data
          this.totalRecords = res.data.total
        })
        .catch(() => {
          this.$store.dispatch('commonComponents/hideLoadingModalAction')
        })
      // this.$store.dispatch('commonComponents/showLoadingModalAction')
      // axios
      //   .post('/' + localStorage.getItem('clinic') + '/bills/index-bills', {
      //     //customer_id: this.user.id,
      //     code: 'TDP',
      //     page: this.pagination.page,
      //     per_page: this.pagination.forPage
      //   })
      //   .then((res) => {
      //     this.$store.dispatch('commonComponents/hideLoadingModalAction')
      //     this.docs = res.data.data
      //     this.totalRecords = res.data.total
      //   })
      //   .catch(() => {
      //     this.$store.dispatch('commonComponents/hideLoadingModalAction')
      //   })
    },
    handleShowPdf(id, nr_fattura) {
      if (id) {
        this.$store.dispatch('commonComponents/showLoadingModalAction')

        axios({
          url: '/' + localStorage.getItem('clinic') + '/bills/' + id + '/pdf',
          method: 'POST',
          responseType: 'blob'
        })
          .then((response) => {
            this.$store.dispatch('commonComponents/hideLoadingModalAction')

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Fattura_' + nr_fattura + '.pdf')
            document.body.appendChild(link)

            this.$store.dispatch('commonComponents/openPdfModal', {
              title: 'Fattura_' + nr_fattura,
              link: url,
              background: false,
              print: () => {
                console.log('PRINT')
              },
              download: () => {
                link.click()
              },
              xml: null,
              table_reference: 'active_bill',
              id_reference: id,
              pdf_signed: true,
              sign_done: () => {}
            })
          })
          .catch(() => {
            this.$store.dispatch('commonComponents/hideLoadingModalAction')
            this.$store.dispatch('commonComponents/openNotificationModal', {
              message: 'Ops, qualcosa è andato storto.'
            })
            this.getBills()
          })
      }
    },
    openExportModal() {
      this.export_modal = true
    },
    closeExportModal() {
      this.export_modal = false
    }
  }
})
</script>
